/* src/app/auth/pages/login/login.component.scss */
.main-head {
  height: 150px;
  background: #FFF;
}
.sidenav {
  height: 100%;
  background-color: rgba(255, 255, 255, 0.45);
  overflow-x: hidden;
  padding-top: 20px;
}
.main {
  padding: 0px 10px;
}
@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }
}
@media screen and (max-width: 450px) {
  .login-form {
    margin-top: 10%;
  }
  .register-form {
    margin-top: 10%;
  }
}
@media screen and (min-width: 768px) {
  .main {
    margin-left: 40%;
  }
  .sidenav {
    width: 40%;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
  }
  .login-form {
    margin-top: 80%;
  }
  .register-form {
    margin-top: 20%;
  }
}
.login-main-text {
  margin-top: 20%;
  padding: 60px;
  color: #666;
}
.login-main-text h2 {
  font-weight: 300;
}
.btn-black {
  background-color: #000 !important;
  color: #fff;
}
.logo {
  width: 20rem;
  margin-left: -2rem;
}
.loginDivider {
  text-align: center;
  color: #94a3b8;
  font-size: 0.8rem;
  margin: 0.75rem 0;
}
/*# sourceMappingURL=login.component.css.map */
